<template>
  <span class="driver-status d-inline-flex align-items-center" :title="statusName">
    <span class="driver-status__dot rounded-circle mr-2" :style="dotStyle"></span>
    {{ statusName }}
  </span>
</template>

<script>
export default {
  name: "DriverStatusIndicator",
  props: {
    status: {
      type: Object,
      default: null
    }
  },
  computed: {
    statusName() {
      return this.status && this.status.name ? this.status.name : "-";
    },
    dotStyle() {
      return { backgroundColor: this.status && this.status.color ? this.status.color : "#3699ff" };
    }
  }
};
</script>

<style scoped>
.driver-status {
  color: #3f4254;
  font-size: 0.85rem;
  font-weight: 600;
  line-height: 1;
}

.driver-status__dot {
  height: 8px;
  min-height: 8px;
  min-width: 8px;
  width: 8px;
}
</style>
